import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import s from './index.module.scss';

export const Features = () => {
  const { t } = useTranslation('reporting-modes');
  return (
    <div className={s.wrapper}>
      <div className={classnames(s.thead, 'f-body-accent')}>
        <div className={s.cell}>{t('features.feature')}</div>
        <div className={s.cell}>{t('features.transparent_mode')}</div>
        <div className={s.cell}>{t('features.opaque_mode')}</div>
      </div>
      <div className={classnames(s.tbody, 'f-body-regular')}>
        <div className={s.row}>
          <div className={s.cell}>{t('features.monthly_reporting_service_fee')}</div>
          <div className={s.cell}>
            <span className="f-hero-h5">{t('features.free')}</span>
          </div>
          <div className={s.cell}>
            <div>
              <Trans
                ns="reporting-modes"
                i18nKey="features.percentage_of_balance"
                components={{
                  Span: <span className="f-hero-h5" />,
                }}
              />
            </div>
            <div style={{ marginTop: '16px' }}>{t('features.monthly_reporting_fee_details')}</div>
          </div>
        </div>
        <div className={s.row}>
          <div className={s.cell}>{t('features.reporting_frequency')}</div>
          <div className={s.cell}>{t('features.full_reporting_package_3_months')}</div>
          <div className={s.cell}>{t('features.full_reporting_package_9_months')}</div>
        </div>
        <div className={s.row}>
          <div className={s.cell}>{t('features.documents_required')}</div>
          <div className={s.cell}>{t('features.bank_statements_full_period')}</div>
          <div className={s.cell}>{t('features.same_full_package')}</div>
        </div>
        <div className={s.row}>
          <div className={s.cell}>{t('features.non_compliance_fee')}</div>
          <div className={s.cell}>
            <Trans
              ns="reporting-modes"
              i18nKey="features.quarterly_package_late"
              components={{
                Span: <span className="f-500" />,
              }}
            />
          </div>
          <div className={s.cell}>
            <Trans
              ns="reporting-modes"
              i18nKey="features.reporting_package_late"
              components={{
                Span: <span className="f-500" />,
              }}
            />
          </div>
        </div>
        <div className={s.row}>
          <div className={s.cell}>{t('features.changing_modes')}</div>
          <div className={s.cell}>{t('features.switch_to_opaque')}</div>
          <div className={s.cell}>
            <Trans
              ns="reporting-modes"
              i18nKey="features.switch_back_to_transparent"
              components={{
                Span: <span className="f-500" />,
              }}
            />
          </div>
        </div>
        <div className={s.row}>
          <div className={s.cell}>{t('features.impact_on_relationship')}</div>
          <div className={s.cell}>{t('features.lowest_ongoing_cost')}</div>
          <div className={s.cell}>
            <Trans
              ns="reporting-modes"
              i18nKey="features.fewer_reporting_periods"
              components={{
                Span: <span className="f-500" />,
              }}
            />
          </div>
        </div>
        <div className={s.flat}>{t('features.exact_reporting_periods')}</div>
      </div>
    </div>
  );
};
